// extracted by mini-css-extract-plugin
module.exports = {"container":"zh-cn_container__2PcO8","content":"zh-cn_content__3o7WI"};